import React, { useState } from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/styles'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import { useSelector, useDispatch } from 'react-redux'
import { Input, Button, Picker } from '../root/components/common'
import { enqueueSnackbar, login as loginUser, setLocale } from '../root/actions'
import { Fade, IconButton } from '@material-ui/core'
import { LOCALE_DISPLAY_OPTIONS } from '../root/constants'
import packageJson from '../../../package.json'

const useStyles = makeStyles(theme => ({
    wrapper: {
        width: '100%',
        height: '100%',
        backgroundColor: theme.background,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative'
    },
    versionWrapper: {
        position: 'absolute',
        bottom: 8,
        left: 21,
        color: theme.textSecondary,
        fontSize: 12
    },
    formWrapper: {
        width: 600,
        '@media (max-width: 767px)': {
            width: '90%'
        },
        '@media (max-width: 320px)': {
            width: '100%'
        }
    },
    loginLogo: {
        backgroundImage: `url("${theme.loginLogo}")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        width: 600,
        height: 200,
        marginBottom: 15,
        '@media (max-width: 767px)': {
            width: '90%'
        },
        '@media (max-width: 320px)': {
            width: '100%'
        }
    },
    input: {
        marginBottom: 15
    },
    actionWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 15
    },
    forgotPasswordActionWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: 15
    },
    link: {
        fontWeight: 'bold',
        color: theme.primary,
        cursor: 'pointer'
    },
    langPickerWrapper: {
        position: 'absolute',
        top: 20,
        right: 20
    },
    showPassIcon: {
        padding: 0,
        position: 'absolute',
        right: 14
    }
}))

function Login(props) {
    const classes = useStyles()
    const dispatch = useDispatch()

    const { token, isTermsStep, twoFactorToken, locale, localeCode } =
        useSelector(state => state.main)
    const [isPassVisible, setIsPassVisible] = useState(false)
    const isLoggedIn = token !== null

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    const login = (em, pswd) => {
        if (!em || em.length === 0) {
            dispatch(
                enqueueSnackbar({
                    message: locale.login.emailIsRequired,
                    options: {
                        variant: 'warning'
                    }
                })
            )
        }
        if (!pswd || pswd.length === 0) {
            dispatch(
                enqueueSnackbar({
                    message: locale.login.passwordIsRequired,
                    options: {
                        variant: 'warning'
                    }
                })
            )
        }
        if (em.length && pswd.length) {
            dispatch(
                loginUser({
                    email: em,
                    password: pswd
                })
            )
        }
    }

    const goToRegister = () => {
        props.history.push('/register')
    }

    const goToForgotPassword = () => {
        props.history.push('/forgot-password')
    }

    const onLanguageSelect = localeCode => {
        dispatch(setLocale(localeCode))
    }

    return (
        <React.Fragment>
            {!isLoggedIn && isTermsStep && (
                <Redirect to={{ pathname: '/ts' }} />
            )}
            {!isLoggedIn && !isTermsStep && twoFactorToken && (
                <Redirect to={{ pathname: '/verify-2fa' }} />
            )}
            {isLoggedIn && !isTermsStep && (
                <Redirect to={{ pathname: '/dashboard' }} />
            )}
            {!isLoggedIn && !isTermsStep && !twoFactorToken && (
                <div className={classes.wrapper}>
                    <div className={classes.versionWrapper}>
                        ver.{packageJson.version}
                    </div>
                    <div className={classes.langPickerWrapper}>
                        <Picker
                            onChange={onLanguageSelect}
                            value={localeCode}
                            options={LOCALE_DISPLAY_OPTIONS}
                        />
                    </div>
                    <Fade in={true} timeout={500}>
                        <div className={classes.formWrapper}>
                            <div className={classes.loginLogo}></div>
                            <Input
                                autoFocus
                                className={classes.input}
                                label={locale.common.email}
                                type="email"
                                setValue={setEmail}
                                onEnter={login.bind(this, email, password)}
                                value={email}
                            />
                            <Input
                                className={classes.input}
                                label={locale.common.password}
                                type={isPassVisible ? 'text' : 'password'}
                                setValue={setPassword}
                                onEnter={login.bind(this, email, password)}
                                value={password}
                                endIcon={() => (
                                    <IconButton
                                        classes={{ root: classes.showPassIcon }}
                                        onClick={() =>
                                            setIsPassVisible(!isPassVisible)
                                        }>
                                        {isPassVisible ? (
                                            <VisibilityOffIcon />
                                        ) : (
                                            <VisibilityIcon />
                                        )}
                                    </IconButton>
                                )}
                            />
                            <div
                                className={classes.forgotPasswordActionWrapper}>
                                <div
                                    onClick={goToForgotPassword}
                                    className={classes.link}>
                                    {locale.login.forgotPassword}
                                </div>
                            </div>
                            <div className={classes.actionWrapper}>
                                <Button
                                    onClick={login.bind(this, email, password)}>
                                    {locale.login.signIn}
                                </Button>
                            </div>
                            <div className={classes.actionWrapper}>
                                <div
                                    onClick={goToRegister}
                                    className={classes.link}>
                                    {locale.login.newInTraplinked}
                                </div>
                            </div>
                        </div>
                    </Fade>
                </div>
            )}
        </React.Fragment>
    )
}

export default withRouter(Login)
